import { INSPECTOR_IDS } from '../inspectors/registry';

export const INSPECTOR_DEFAULT = INSPECTOR_IDS.DEFAULT;
export const INSPECTOR_BUS = INSPECTOR_IDS.BUS;
export const INSPECTOR_POWER_SWITCH = INSPECTOR_IDS.POWER_BREAKER;
export const INSPECTOR_THERMOMAGNETIC_SWITCH = INSPECTOR_IDS.THERMOMAGNETIC_SWITCH;
export const INSPECTOR_OVERLOADRELAY = INSPECTOR_IDS.OVERLOAD_RELAY;
export const INSPECTOR_INDUCTION_MOTOR = INSPECTOR_IDS.INDUCTION_MOTOR;
export const INSPECTOR_SYNCHRONOUS_MOTOR = INSPECTOR_IDS.SYNCHRONOUS_MOTOR;
export const INSPECTOR_VFD = INSPECTOR_IDS.VFD;
export const INSPECTOR_SOFT_STARTER = INSPECTOR_IDS.SOFT_STARTER;
export const INSPECTOR_DISTRIBUTION_BOARD = INSPECTOR_IDS.DISTRIBUTION_BOARD;
export const INSPECTOR_LIGHTNING_CONTACT_CHARGING_CENTER = INSPECTOR_IDS.MEASUREMENT;
export const INSPECTOR_GENERATORS = INSPECTOR_IDS.GENERATOR;
export const INSPECTOR_PHOTOVOLTAIC_GENERATORS = INSPECTOR_IDS.PHOTOVOLTAIC_GENERATOR;
export const INSPECTOR_ELECTRIC_ENERGY_SUPPLIER = INSPECTOR_IDS.POWER_SUPPLIER;
export const INSPECTOR_FIXED_CAPACITOR_BANK = INSPECTOR_IDS.FIXED_CAPACITOR_BANK;
export const INSPECTOR_AUTOMATIC_CAPACITOR_BANK = INSPECTOR_IDS.AUTOMATIC_CAPACITOR_BANK;
export const INSPECTOR_UPS = INSPECTOR_IDS.UPS;
export const INSPECTOR_TWO_WINDING_TRANSFORMER = INSPECTOR_IDS.TWO_WINDING_TRANSFORMER;
export const INSPECTOR_THREE_WINDING_TRANSFORMER = INSPECTOR_IDS.THREE_WINDING_TRANSFORMER;
export const INSPECTOR_CABLES = INSPECTOR_IDS.CABLE;
export const INSPECTOR_ELECTROMAGNETIC_SWITCH = INSPECTOR_IDS.POWER_BREAKER;
export const INSPECTOR_ELECTRONIC_RELAY = INSPECTOR_IDS.VFD;
export const INSPECTOR_PROTECTION_RELAY = INSPECTOR_IDS.PROTECTION_RELAY;
export const INSPECTOR_RESTAURATEUR = INSPECTOR_IDS.RESTAURATEUR;
export const INSPECTOR_SWITCH = INSPECTOR_IDS.DEFAULT;
export const INSPECTOR_ELECTRIC_EQUIPMENT = INSPECTOR_IDS.DEFAULT;
export const INSPECTOR_MAGNETIC_SWITCH = INSPECTOR_IDS.DEFAULT;
export const INSPECTOR_FUSE = INSPECTOR_IDS.FUSES;
export const INSPECTOR_FUSE_MT = INSPECTOR_IDS.DEFAULT;
export const INSPECTOR_ENGINE_CONTROL_CENTER = INSPECTOR_IDS.DISTRIBUTION_BOARD;
export const INSPECTOR_ELECTRODUCTS = INSPECTOR_IDS.DEFAULT;
export const INSPECTOR_DISTRIBUTION_LINES = INSPECTOR_IDS.DEFAULT;
export const INSPECTOR_SUBDIAGRAM = INSPECTOR_IDS.DEFAULT;
export const INSPECTOR_TEXT_BOX = INSPECTOR_IDS.TEXT_BOX;
export const INSPECTOR_BOX = INSPECTOR_IDS.BOX;
